var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable complexity, react/display-name */
import React, { forwardRef, useRef, useState, useEffect, useCallback, useContext } from 'react';
import cx from 'classnames';
import { Modal as MuiModal, Fade, Backdrop } from '@material-ui/core';
import { ThemeContext } from 'styled-components';
import { Container, Icon, Typography, Grid } from '../';
import { useOutsideClick } from '../../hooks';
import { getBPHelpers } from '../../utils/breakpoints';
import ModalActions from '../ModalActions';
import * as S from './styles';
export var Modal = forwardRef(function Modal(_a, ref) {
    var closeHandler = _a.closeHandler, title = _a.title, size = _a.size, disableBackdropClick = _a.disableBackdropClick, open = _a.open, noPadding = _a.noPadding, backdropColor = _a.backdropColor, hideCloseHandler = _a.hideCloseHandler, children = _a.children, className = _a.className, style = _a.style, rest = __rest(_a, ["closeHandler", "title", "size", "disableBackdropClick", "open", "noPadding", "backdropColor", "hideCloseHandler", "children", "className", "style"]);
    var _b = useState('center'), alignItems = _b[0], setAlignItems = _b[1];
    var refPaper = useRef();
    var themeContext = useContext(ThemeContext);
    var BPHelpers = getBPHelpers(themeContext.breakpoints);
    var screens = BPHelpers.useScreens();
    var screenSize = BPHelpers.useScreenSize();
    var screenWidth = screenSize.width;
    var screenHeight = screenSize.height;
    var calculateAlignment = useCallback(function () {
        var modalHeight = refPaper.current ? refPaper.current.offsetHeight : 0;
        setAlignItems(modalHeight > screenHeight ? 'flex-start' : 'center');
    }, [refPaper, screenHeight]);
    useEffect(function () {
        var modalHeight = refPaper.current ? refPaper.current.offsetHeight : 0;
        setAlignItems(modalHeight > screenHeight ? 'flex-start' : 'center');
    }, [screenWidth, screenHeight]);
    useOutsideClick(refPaper, disableBackdropClick ? undefined : closeHandler);
    var sizeClassName = size + "-size";
    var rootClass = cx(sizeClassName, className);
    var backdropBackground = backdropColor === 'white' ? 'rgba(210, 210, 210, 0.5)' : 'rgba(0, 0, 0, 0.5)';
    var backdropProps = {
        style: { backgroundColor: backdropBackground, backdropFilter: 'blur(6px)' },
        timeout: 200
    };
    var padding = screens({
        small: 'small',
        medium: 'large'
    }, 'xlarge');
    var margin = screens({
        small: 'xsmall',
        medium: 'medium'
    }, 'large');
    var fullscreenStyles = size === 'fullscreen'
        ? {
            flexGrow: 1,
            minHeight: '100%',
            width: '100%'
        }
        : { width: '100%' };
    return (React.createElement(MuiModal, __assign({ onBackdropClick: disableBackdropClick ? undefined : closeHandler, open: open, BackdropComponent: Backdrop, BackdropProps: backdropProps, closeAfterTransition: true, onRendered: calculateAlignment, ref: ref }, rest),
        React.createElement(Fade, { timeout: 200, in: open },
            React.createElement(S.ContentWrapper, { className: rootClass, style: style, flex: true, justifyContent: 'center', alignItems: alignItems, padded: size !== 'fullscreen' ? margin : undefined },
                React.createElement(Container, { flex: true, justifyContent: 'center', style: fullscreenStyles },
                    React.createElement(S.Content, { inverted: true, ref: refPaper },
                        React.createElement(Container, { padded: noPadding ? undefined : padding, flex: true, fullWidth: true, direction: 'column', style: fullscreenStyles },
                            React.createElement(Container, null,
                                React.createElement(Grid, { spacing: 'small', wrap: 'nowrap', justifyContent: 'space-between', alignItems: 'center', style: title ? {} : { textAlign: 'right' } },
                                    title && (React.createElement(Grid.Item, { style: { flex: 1 } },
                                        React.createElement(Typography, { as: 'span', variant: 'heading', size: 'large', weight: 'semibold' }, title))),
                                    !hideCloseHandler && (React.createElement(Grid.Item, { style: title ? {} : { flex: 1 } },
                                        React.createElement(Icon, { as: 'link', name: 'cross', onClick: closeHandler, size: 'small' }))))),
                            React.createElement(Container, { top: title ? 'small' : undefined, flex: true, fullWidth: true, direction: 'column', style: fullscreenStyles }, children))))))));
});
Modal.defaultProps = {
    backdropColor: 'white',
    size: 'adaptive',
    noPadding: false,
    hideCloseHandler: false
};
Modal.Actions = ModalActions;
Modal.displayName = 'Modal';
export default Modal;
//# sourceMappingURL=Modal.js.map